import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  content: {
    description: 'message to a user explaining that their API key is about to expire',
    defaultMessage: 'You have an API key that is expiring soon.',
    id: 'xdviY5',
  },
  learnMore: {
    description: 'button text that will take users to a settings page where they are able to manage their API keys and related credentials',
    defaultMessage: 'View your API settings',
    id: 'weRsVf',
  },
});
